import { db, storage } from '../firebaseInit'
import router from '../router'

export default {
  state: {
    builderProjects: [],
    contactProjects: [],
    project: null,
    projectList: [],
    projectFiles: [],
    projectPhotos: [],
    projectPlans: [],
    projectSearch: []
  },
  mutations: {
    updateProjectStatus (state, payload) {
      state.project.status = payload
    },
    completeProject (state, payload) {
      state.project = { ...state.project, ...payload.data }
      state.projectList[payload.index] = { ...state.projectList[payload.index], ...payload.data }
    },
    builderProjects (state, payload) {
      state.builderProjects = payload
    },
    contactProjects (state, payload) {
      state.contactProjects = payload
    },
    projectUpdate (state, payload) {
      Object.assign(state.project, payload.newState)
    },
    deletePhoto (state, payload) {
      state.projectPhotos.splice(payload, 1)
    },
    clearProjectPhotos (state) {
      state.projectPhotos = []
    },
    getProjectPhotos (state, payload) {
      state.projectPhotos.push(payload)
    },
    projectPhotos (state, payload) {
      state.projectPhotos.push(payload)
    },
    additionalContact (state, payload) {
      state.project.additional_contacts = payload.project.additional_contacts
    },
    newProjectPlan (state, payload) {
      state.projectPlans.push(payload)
    },
    removeAssignedUser (state, payload) {
      state.project.assigned_to = payload.project.assigned_to
    },
    assignUser (state, payload) {
      state.project.assigned_to = payload.project.assigned_to
    },
    addNewTaskToProject (state, payload) {
      state.project.tasks = payload
    },
    projectSearch (state, payload) {
      state.projectSearch = payload
    },
    getProjectPlans (state, payload) {
      state.projectPlans = payload
    },
    destroyProject (state) {
      state.projectFiles = []
      state.projectPlans = []
      state.project = null
    },
    fileNameUpdate (state, payload) {
      state.projectFiles[payload.index].name = payload.new_name
    },
    deleteFile (state, payload) {
      state.projectFiles.splice(payload, 1)
    },
    projectFiles (state, payload) {
      state.projectFiles.push(payload)
    },
    getFileList (state, payload) {
      state.projectFiles = payload
    },
    getProject (state, payload) {
      state.project = payload
    },
    getProjectList (state, payload) {
      state.projectList = payload
    },
    createProject (state, payload) {
      state.projectList.push(payload)
    },
    editProject (state, payload) {
      state.projectList[payload.index] = { ...state.projectList[payload.index], ...payload.changes }
      state.project = { ...state.project, ...payload.changes }
    },
    deleteProject (state, payload) {
      state.projectList.splice(payload, 1)
    }
  },
  actions: {
    changeProjectCustomer ({ commit, getters, dispatch }, payload) {
      // Set Old Project to New Contact
      // Clear Previous Contact Owner from Project
      payload.project.contacts[payload.fromContact.id] = false
      // Add New Contact Owner to Project
      payload.project.contacts[payload.toContact.id] = true
      db.collection('projects').doc(payload.project.id).update({contacts: payload.project.contacts})
      // Set Old Contact Project to False
      payload.fromContact.projects[payload.project.id] = false
      db.collection('contacts').doc(payload.fromContact.id).update({projects: payload.fromContact.projects})
      // Set New Contact Project to True
      if (!payload.toContact.projects) {
        payload.toContact.projects = {}
      }
      payload.toContact.projects[payload.project.id] = true
      db.collection('contacts').doc(payload.toContact.id).update({projects: payload.toContact.projects})
      const logData = { timestamp: new Date(), collection: 'projects', type: 'change user', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' changed the contact for the project: ' + payload.project.name + ' to ' + payload.toContact.id, icon: 'person' }
      dispatch('commitLog', logData)
    },
    deleteProjectPlan ({ commit, getters, dispatch }, payload) {
      let projectPlans = []
      db.collection('projects').doc(payload.projectId).collection('plans').doc(payload.plan.file_id).update({active: false}).then(query => {
        const logData = { timestamp: new Date(), collection: 'projects - plans', type: 'deleted', user_id: getters.user.id, record_id: payload.projectId + ' - ' + payload.plan.file_id, message: getters.user.first_name + ' deleted a project plan for the project: ' + payload.project_name, icon: 'photo_camera' }
        dispatch('commitLog', logData)
        db.collection('projects').doc(payload.projectId).collection('plans').where('active', '==', true).get().then(query => {
          query.forEach(item => {
            storage.ref(item.data().path).getDownloadURL().then(url => {
              let data = { ...item.data(), file_id: item.id, url: url }
              projectPlans.push(data)
            })
          })
        })
          .then(() => commit('getProjectPlans', projectPlans))
      })
    },
    rotateImage ({ commit }, payload) {
      db.collection('projects').doc(payload.project.id).collection('photos').doc(payload.photo.file_id).update({
        rotate: payload.photo.rotate
      })
    },
    completeProject ({ commit, state }, payload) {
      db.collection('projects').doc(payload.id).update({
        active: false,
        status: 'Completed',
        completed_date: new Date()
      })
        .then(() => {
          const projectListIndex = state.projectList.findIndex(i => i.id === payload.id)
          const data = { status: 'Completed', completed_date: { seconds: new Date().getTime() } }
          commit('completeProject', { index: projectListIndex, data: data })
          // Code that sets the projectStatus for each task - used in filtering tasks
          db.collection('projects').doc(payload.id).get().then(result => {
            if (result.data().tasks) {
              let taskData = Object.keys(result.data().tasks)
              taskData.forEach(task => {
                db.collection('tasks').doc(task).update({ projectStatus: 'Completed' })
              })
            }
          })
        })
    },
    builderProjects ({ commit }, payload) {
      let projects = []
      db.collection('projects').where('builder', '==', payload.builder).where('deleted', '==', false).get().then(project => {
        project.forEach(data => {
          if (data.data().deleted !== true && data.data().revertedToLeads !== true) {
            let tasks = []
            if (data.data().tasks) {
              let taskIds = data.data().tasks
              taskIds = Object.keys(taskIds)
              taskIds.forEach(taskId => {
                db.collection('tasks').doc(taskId).get().then(task => {
                  if (task.data().deleted !== true) {
                    tasks.push({ ...task.data(), id: task.id })
                  }
                })
              })
            }
            projects.push({ ...data.data(), id: data.id, tasks: tasks })
          }
        })
      })
      commit('builderProjects', projects)
    },
    contactProjects ({ commit }, payload) {
      let projects = []
      db.collection('contacts').doc(payload).get().then(query => {
        let projectIds = query.data().projects
        projectIds = Object.keys(projectIds)
        projectIds.forEach(project => {
          db.collection('projects').doc(project).get().then(data => {
            if (data.data().tasks && data.data().deleted !== true) {
              let taskIds = data.data().tasks
              taskIds = Object.keys(taskIds)
              let tasks = []
              taskIds.forEach(taskId => {
                db.collection('tasks').doc(taskId).get().then(task => {
                  if (task.data().deleted !== true) {
                    tasks.push({ ...task.data(), id: task.id })
                  }
                })
              })
              projects.push({ ...data.data(), id: data.id, tasks: tasks })
            }
          })
        })
      })
      commit('contactProjects', projects)
    },
    projectUpdate ({ commit, state }, payload) { // Calls for the following: {project: this.project, newState: {status: 'Construction'}, previousState: {status: this.project.status}}
      db.collection('projects').doc(payload.project.id).update(payload.newState).then(() => {
        commit('projectUpdate', payload)
      }).then(() => {
        // Code that sets the projectStatus for each task - used in filtering tasks
        db.collection('projects').doc(payload.project.id).get().then(result => {
          if (result.data().tasks) {
            let projectStatus = result.data().status
            let taskData = Object.keys(result.data().tasks)
            taskData.forEach(task => {
              db.collection('tasks').doc(task).update({ projectStatus: projectStatus })
            })
          }
        })
      })
    },
    deletePhoto ({ commit, state }, payload) {
      db.collection('projects').doc(payload.project.id).collection('photos').doc(payload.photo.file_id).update({
        active: false
      })
        .then(() => {
          const index = state.projectPhotos.findIndex(i => i.file_id === payload.photo.file_id)
          commit('deletePhoto', index)
        })
    },
    clearProjectPhotos ({ commit }) {
      commit('clearProjectPhotos')
    },
    getProjectPhotos ({ commit, state }, payload) {
      db.collection('projects').doc(payload.project.id).collection('photos').where('active', '==', true).get().then(response => {
        state.projectPhotos = []
        response.forEach(file => {
          // Get Secure Download URL
          let data = null
          storage.ref(file.data().path).getDownloadURL().then(url => {
            data = { ...file.data(), file_id: file.id, url: url }
          }).then(() => {
            const path = file.data().path
            const thumbURL = path.substring(0, path.lastIndexOf('/') + 1) + file.data().thumbnail
            storage.ref(thumbURL).getDownloadURL().then(thumbURL => {
              data.thumbnailURL = thumbURL
              commit('getProjectPhotos', data)
            })
          })
            .catch(error => {
              console.log('Could not authorize download. Error Message: ', error)
            })
        })
      })
    },
    projectPhotos ({ commit, state, getters, dispatch }, payload) {
      payload.files.forEach(element => {
        let data = []
        db.collection('projects').doc(element.id).collection('photos').add(element)
          .then(response => {
            if (payload.task_id) {
              dispatch('taskFile', { task_id: payload.task_id, project_id: payload.id, file_id: response.id })
            }
            element.file_id = response.id
            const logData = { timestamp: new Date(), collection: 'projects - photos', type: 'uploaded', user_id: getters.user.id, record_id: element.id + ' - ' + response.id, message: getters.user.first_name + ' uploaded the photo: [' + element.name + '] to the project: ' + payload.project_name, icon: 'photo_camera' }
            dispatch('commitLog', logData)
          }).then(() => {
            storage.ref(element.path).getDownloadURL().then(url => {
              data = { ...element, file_id: element.file_id, url: url, timestamp: { seconds: (Math.round(new Date().getTime() / 1000)) - 1 } }
            })
              .then(() => {
                const path = element.path
                const thumbURL = path.substring(0, path.lastIndexOf('/') + 1) + element.thumbnail
                storage.ref(thumbURL).getDownloadURL().then(thumbURL => {
                  data.thumbnailURL = thumbURL
                  commit('projectPhotos', data)
                })
              })
          })
          .catch(error => {
            console.log('ERROR!', error)
          })
      })
    },
    additionalContact ({ commit, state, dispatch, getters }, payload) { // Payload = { project: project, type: add / delete / edit }
      db.collection('projects').doc(payload.project.id).update({
        additional_contacts: payload.project.additional_contacts
      })
        .then(() => {
          commit('additionalContact', payload)
          if (payload.type === 'new') {
            const logData = { timestamp: new Date(), collection: 'project', type: 'Added Additional Contact', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' added the additional contact ' + payload.newContact + ' to the project: ' + payload.project.name, icon: 'person' }
            dispatch('commitLog', logData)
          }
          if (payload.type === 'edit') {
            const logData = { timestamp: new Date(), collection: 'project', type: 'Edited Additional Contact', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' edited the additional contact ' + payload.contactName + ' of the project: ' + payload.project.name, icon: 'person' }
            dispatch('commitLog', logData)
          }
          if (payload.type === 'delete') {
            const logData = { timestamp: new Date(), collection: 'project', type: 'Deleted Additional Contact', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' deleted the additional contact ' + payload.contactName + ' to the project: ' + payload.project.name, icon: 'person' }
            dispatch('commitLog', logData)
          }
        })
    },
    removeAssignedUser ({ commit, state, dispatch, getters }, payload) { // Payload = { project: project }
      db.collection('projects').doc(payload.project.id).update({
        assigned_to: payload.project.assigned_to
      })
        .then(() => {
          commit('removeAssignedUser', payload)
          const logData = { timestamp: new Date(), collection: 'project', type: 'Removed Assigned User', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' removed the assigned user ' + payload.user.first_name + ' ' + payload.user.last_name + ' from the project: ' + payload.project.name, icon: 'ballot' }
          dispatch('commitLog', logData)
        })
    },
    assignUser ({ commit, state, dispatch, getters }, payload) { // Payload = { project: project }
      db.collection('projects').doc(payload.project.id).update({
        assigned_to: payload.project.assigned_to
      })
        .then(() => {
          commit('assignUser', payload)
          const logData = { timestamp: new Date(), collection: 'project', type: 'assign user', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' assigned the user ' + payload.user.first_name + ' ' + payload.user.last_name + ' to the project: ' + payload.project.name, icon: 'ballot' }
          dispatch('commitLog', logData)
        })
    },
    addNewTaskToProject ({ commit, dispatch, state }, payload) { // Payload = {project: project, taskId: taskId}
      console.log('Add New Task To Project Payload', payload)
      commit('addNewTaskToProject', payload)
      // if (!payload.project.tasks) {
      //   payload.project.tasks = []
      // }
      // payload.project.tasks[payload.taskId] = true
      // db.collection('projects').doc(payload.project.id).update({
      //   tasks: payload.project.tasks
      // })
      //   .then(() => {
      //     commit('addNewTaskToProject', payload)
      //     // dispatch('updateSummaryProject', {project: payload.project})
      //   })
    },
    projectSearch ({ commit, getters }) {
      let projectList = []
      db.collection('projects').where('deleted', '==', false).get().then(query => {
        query.forEach(project => {
          if (getters.user.permissions.projects.view.assigned && !project.data().revertedToLeads) {
            if (project.data().assigned_to.includes(getters.user.id)) {
              projectList.push({ name: project.data().name, id: project.id, type: 'Project', start_date: project.data().start_date, job_number: project.data().job_number, address: project.data().address, city: project.data().city })
            }
          } else if (getters.user.permissions.projects.view.none) {
          } else {
            if (!project.data().revertedToLeads) {
              projectList.push({ name: project.data().name, id: project.id, type: 'Project', start_date: project.data().start_date, job_number: project.data().job_number, address: project.data().address, city: project.data().city })
            }
          }
        })
      })
        .then(() => {
          commit('projectSearch', projectList)
        })
    },
    getProjectPlans ({ commit }, payload) {
      let projectPlans = []
      db.collection('projects').doc(payload).collection('plans').where('active', '==', true).get().then(query => {
        query.forEach(item => {
          storage.ref(item.data().path).getDownloadURL().then(url => {
            let data = { ...item.data(), file_id: item.id, url: url }
            projectPlans.push(data)
          })
        })
      })
        .then(() => commit('getProjectPlans', projectPlans))
    },
    newProjectPlan ({ commit, getters, dispatch }, payload) {
      db.collection('projects').doc(payload.project_id).collection('plans').add(payload.files[0])
        .then(response => {
          commit('newProjectPlan', payload.files[0])
          const logData = { timestamp: new Date(), collection: 'projects - files', type: 'uploaded', user_id: getters.user.id, record_id: payload.project_id + ' - ' + response.id, message: getters.user.first_name + ' uploaded the new Pool Plan: [' + payload.files[0].name + '] to the project: ' + payload.project_name, icon: 'border_outer' }
          dispatch('commitLog', logData)
        })
        .catch(error => {
          console.log('ERROR!', error)
        })
    },
    destroyProject ({ commit }) {
      commit('destroyProject')
    },
    getFileList ({ commit }, payload) {
      let fileList = []
      db.collection('projects').doc(payload).collection('files').where('active', '==', true).get().then(query => {
        query.forEach(file => {
          // Get Secure Download URL
          storage.ref(file.data().path).getDownloadURL().then(url => {
            let data = { ...file.data(), file_id: file.id, url: url }
            fileList.push(data)
          })
            .catch(error => {
              console.log('Could not authorize download. Error Message: ', error)
            })
        })
      }).then(() => {
        commit('getFileList', fileList)
      })
    },
    deleteFile ({ commit, getters, dispatch, state }, payload) {
      db.collection('projects').doc(payload.project_id).collection('files').doc(payload.file_id).update({
        active: false
      })
      const logData = { timestamp: new Date(), collection: 'projects - files', type: 'deleted', user_id: getters.user.id, record_id: payload.project_id + ' - ' + payload.file_id, message: getters.user.first_name + ' deleted the file: ' + payload.name, icon: 'file_copy' }
      dispatch('commitLog', logData)
      const index = state.projectFiles.findIndex(i => i.name === payload.name)
      commit('deleteFile', index)
    },
    fileNameUpdate ({ commit, getters, dispatch, state }, payload) {
      db.collection('projects').doc(payload.project_id).collection('files').doc(payload.file_id).update({
        name: payload.new_name
      })
      const logData = { timestamp: new Date(), collection: 'projects - files', type: 'edited', user_id: getters.user.id, record_id: payload.project_id + ' - ' + payload.file_id, changed_from: { name: payload.old_name }, changed_to: { name: payload.new_name }, message: getters.user.first_name + ' edited the file name: ' + payload.new_name, icon: 'file_copy' }
      dispatch('commitLog', logData)
      const index = state.projectFiles.findIndex(i => i.name === payload.old_name)
      const newPayload = { new_name: payload.new_name, index: index }
      commit('fileNameUpdate', newPayload)
    },
    getProject ({ commit, getters }, payload) {
      db.collection('projects').doc(payload).get().then(query => {
        let assigned = null
        if (query.data() && query.data().assigned_to) {
          assigned = query.data().assigned_to.includes(getters.user.id)
        }
        const project = { ...query.data(), id: query.id, assigned: assigned }
        commit('getProject', project)
      })
    },
    getProjectList ({ commit, state, dispatch, getters }, payload) { // Expects Payload: {status: <Project Status> OR 'All', projectFilters: <array of Inactive, Active>, assignedOnly: <true/false>, tasks: <true or false | Include Tasks Details?>}
      return new Promise((resolve, reject) => {
        return new Promise(resolve => {
          commit('setLoading', true)
          state.projectList = []
          let projectData = []
          let query = null
          const userId = getters.user.id
          if (getters.user.permissions.projects.view.none) {
            // query = db.collection('projects').where('deleted', '==', false).where('status', '==', payload.status).where('assigned_to', 'array_contains', 'JbFgEJI5NkUQOP0gFzrEdm7bNMs2')
            query = db.collection('projects').where('XXXXX', '==', true)
          } else if (payload.status === 'All') {
            query = db.collection('projects').where('deleted', '==', false)
          } else {
            query = db.collection('projects').where('deleted', '==', false).where('status', '==', payload.status)
          }
          query.get().then(response => {
            response.forEach(res => {
              if (getters.user.permissions.projects.view.assigned || payload.assignedOnly) {
                if (res.data().assigned_to.includes(userId)) {
                  projectData.push({ ...res.data(), id: res.id, assigned: true })
                }
              } else {
                const assigned = res.data().assigned_to.includes(userId)
                projectData.push({ ...res.data(), id: res.id, assigned: assigned })
              }
            })
            let array = []
            projectData.forEach(item => {
              let record = item
              let assignedTo = []
              record.assigned_to.forEach(assignment => {
                db.collection('users').doc(assignment).get().then(assignedName => {
                  assignedTo.push(assignedName.data())
                })
              })
              record = { ...record, assigned_to: assignedTo }
              array.push(record)
            })
            resolve(array)
          })
        })
          // Get Tasks (Requires payload: tasks: true)
          .then(projects => {
            if (payload.tasks && payload.tasks === true) {
              let projectArray = []
              projects.forEach(project => {
                if (project.tasks) {
                  const taskIds = Object.keys(project.tasks)
                  let tasks = []
                  taskIds.forEach(task => {
                    db.collection('tasks').doc(task).get().then(response => {
                      if (response.data().vendor_id) {
                        db.collection('vendors').doc(response.data().vendor_id).get().then(vendor => {
                          // tasks.push({ ...response.data(), vendor_name: vendor.data().company_name })
                          if (vendor.data() && vendor.data().company_name) {
                            tasks.push({ status: response.data().status, vendor_name: vendor.data().company_name })
                          }
                        })
                      } else {
                        // tasks.push(response.data())
                        tasks.push({ status: response.data().status })
                      }
                    })
                  })
                  projectArray.push({ ...project, tasks: tasks })
                } else {
                  projectArray.push(project)
                }
              })
              commit('getProjectList', projectArray)
              commit('setLoading', false)
              resolve()
            } else {
              commit('getProjectList', projects)
              commit('setLoading', false)
              resolve()
            }
          })
      })
    },
    createProject ({ commit, state, dispatch, getters }, payload) {
      const { contact_id, ...withoutContactId } = payload // removes the contact_id
      const { id, ...withoutProjectId } = withoutContactId // removes the project_id
      const { files, ...withoutFiles } = withoutProjectId // removes the files object
      // Get Current Project ID
      let jobNumber = null
      db.collection('settings').doc('client_settings').get().then(settings => {
        if (!payload.completedProject) {
          jobNumber = settings.data().current_job_number
        }
      }).then(() => {
        const newProject = { ...withoutFiles, id: payload.id, created_by: getters.user.id, active: true, deleted: false, assigned_to: [], job_number: jobNumber, created_date: new Date() }
        newProject.assigned_to.push(getters.user.id)
        db.collection('projects').doc(payload.id).set(newProject).then(doc => {
          const logData = { timestamp: new Date(), collection: 'projects', type: 'created', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' created a new project: ' + payload.name, icon: 'ballot' }
          dispatch('commitLog', logData)
          dispatch('projectOnContact', payload)
          dispatch('contactOnProject', payload)
          dispatch('projectFiles', payload)
          // Fix start_date for push
          const newPayload = { ...payload, start_date: { seconds: parseInt(new Date(payload.start_date).getTime() / 1000) } }
          commit('createProject', newPayload)
          // Increment Database Job Number
          if (!payload.completedProject) {
            db.collection('settings').doc('client_settings').update({current_job_number: jobNumber + 1})
          }
        })
          .catch(error => {
            console.log('ERROR Creating Project! Error: ', error)
            this.$store.dispatch('setError', { timestamp: new Date(), collection: 'projects', type: 'setContact', user_id: getters.user.id, route: '/contacts/projectDialog', error: error })
          })
      }).then(() => {
        // If Creating a Completed Project - Write the Opportunity Array Back to the Contact so that revenue reports can be generated
        if (payload.completedProject) {
          let allOpps = []
          db.collection('contacts').doc(payload.contact_id).get().then(contact => {
            if (contact.data().opportunities && contact.data().opportunities.length > 0) {
              allOpps = contact.data().opportunities
            }
            allOpps.push({active: false, deleted: false, address: payload.address, budget_max: payload.budget_max, budget_min: payload.budget_min, builder: payload.builder, builder_contact: payload.builder_contact, building_dept: payload.building_dept, city: payload.city, closed_date: payload.completed_date, contract_amount: payload.contract_amount, created_date: payload.start_date, description: payload.description, financing: payload.financing, gate_code: payload.gate_code, hoa: payload.hoa, other_designs: payload.other_designs, project: payload.id, projectNotes: payload.projectNotes, property_survey: payload.property_survey, referred_by: payload.referred_by ? payload.referred_by : null, revertedToLeads: null, sales_rep: payload.sales_rep, source: payload.source, state: payload.state, status: 'Closed - Won', zip: payload.zip})
          }).then(() => {
            db.collection('contacts').doc(payload.contact_id).update({opportunities: allOpps})
          })
        }
      })
    },
    projectOnContact ({ commit, state }, payload) {
      db.collection('contacts').doc(payload.contact_id).update({
        ['projects.' + payload.id]: true
      })
        .then(() => {
          console.log('Successful ProjectId-to-Contact write on Database!')
        })
        .catch(error => {
          console.log('ERROR!', error)
        })
    },
    contactOnProject ({ commit, state }, payload) {
      db.collection('projects').doc(payload.id).update({
        ['contacts.' + payload.contact_id]: true
      })
        .then(() => {
          console.log('Successful ContactId-to-Project write on Database!')
        }).then(() => {
          // Push to new Project Route
          console.log('Project Payload', payload)
          router.push('/project/' + payload.id)
        })
        .catch(error => {
          console.log('ERROR!', error)
        })
    },
    projectFiles ({ commit, state, getters, dispatch }, payload) {
      payload.files.forEach(element => {
        db.collection('projects').doc(element.id).collection('files').add(element)
          .then(response => {
            if (payload.task_id) {
              dispatch('taskFile', { task_id: payload.task_id, project_id: payload.id, file_id: response.id })
            }
            const logData = { timestamp: new Date(), collection: 'projects - files', type: 'uploaded', user_id: getters.user.id, record_id: element.id + ' - ' + response.id, message: getters.user.first_name + ' uploaded the file: [' + element.name + '] to the project: ' + payload.project_name, icon: 'file_copy' }
            dispatch('commitLog', logData)
            storage.ref(element.path).getDownloadURL().then(url => {
              let data = { ...element, file_id: element.id, url: url, timestamp: { seconds: (Math.round(new Date().getTime() / 1000)) - 1 } }
              commit('projectFiles', data)
            })
          })
          .catch(error => {
            console.log('ERROR!', error)
          })
      })
    },
    editProject ({ commit, state, dispatch, getters }, payload) {
      db.collection('projects').doc(payload.id).update(payload.changes).then(() => {
        const logData = { timestamp: new Date(), collection: 'projects', type: 'edited', user_id: getters.user.id, record_id: payload.id, changed_from: payload.changesFrom, changed_to: payload.changes, message: getters.user.first_name + ' made changes to project: ' + payload.name, icon: 'ballot' }
        dispatch('commitLog', logData)
        const index = state.projectList.findIndex(i => i.id === payload.id)
        const newPayload = { ...payload, index: index }
        commit('editProject', newPayload)
      })
        .catch(error => console.log('Database Error: ', error))
    },
    deleteProject ({ commit, state, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        // Update Project Docs
        db.collection('projects').doc(payload.id).update({ deleted: true, active: false })
        const logData = { timestamp: new Date(), collection: 'projects', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the project: ' + payload.name, icon: 'ballot' }
        dispatch('commitLog', logData)
        const index = state.projectList.findIndex(i => i.id === payload.id)
        commit('deleteProject', index)
        resolve()
      })
    }
  },
  getters: {
    builderProjects (state) {
      return state.builderProjects
    },
    contactProjects (state) {
      return state.contactProjects
    },
    projectPhotos (state) {
      return state.projectPhotos
    },
    projectSearch (state) {
      return state.projectSearch
    },
    projectPlans (state) {
      return state.projectPlans
    },
    getProject (state) {
      return state.project
    },
    projectList (state) {
      return state.projectList
    },
    projectFiles (state) {
      return state.projectFiles
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/projects.js